import { render } from "./inputarray.vue?vue&type=template&id=72f5687a"
import script from "./inputarray.vue?vue&type=script&lang=js"
export * from "./inputarray.vue?vue&type=script&lang=js"

import "./inputarray.vue?vue&type=style&index=0&id=72f5687a&lang=scss"

import exportComponent from "/prodflopclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__